import { Record, Map } from 'immutable';
import { fetchListActions, fetchAllMessagesActions, dismissMessageActions, fetchMessageStatsActions, recordMessagesViewedActions, pagingActions, actionTypes } from './messages.actions';
import * as api from '../../api';
import { pagingDataUtilities } from '../../common';

export const DashboardMessageState = Record({
  listState: api.ApiCallState({}),
  allMessagesState: api.ApiCallState({}),
  statsState: api.ApiCallState({}),
  viewedPageState: api.ApiCallState({}),
  pagingData: pagingDataUtilities.PagingState({
    itemsPerPage: 50,
    sortBy: 'published-date',
    sortAsc: false,
  }),
  messageDismissals: Map({}),
  dismissTarget: null,
});

export const messagesReducer = (initialState = new DashboardMessageState(), action) => {

  var invalidateActions = [dismissMessageActions.success];
  var state = initialState.set('listState',
    api.apiCallReducer(initialState.get('listState'), action, fetchListActions, invalidateActions));

  invalidateActions = invalidateActions.concat(pagingActions.allTypes);
  state = state.set('allMessagesState',
    api.apiCallReducer(state.get('allMessagesState'), action, fetchAllMessagesActions, invalidateActions));

  state = state.set('statsState',
    api.apiCallReducer(state.get('statsState'), action, fetchMessageStatsActions));

  state = state.set('viewedPageState',
    api.apiCallReducer(state.get('viewedPageState'), action, recordMessagesViewedActions));

  state = state.set('pagingData',
    pagingDataUtilities.pagingReducer(state.get('pagingData'), action, pagingActions));

  if(action.messageId) {
    state = state.setIn(['messageDismissals', action.messageId],
      api.apiCallReducer(state.getIn(['messageDismissals', action.messageId]), action, dismissMessageActions));
  }

  switch(action.type) {
    case actionTypes.SET_DISMISS_TARGET:
      return state.set('dismissTarget', action.messageId);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// src/dashboard/messages/messages.reducer.js